import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_ctx.imgUrl)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "head-banner-wrapper",
        style: _normalizeStyle(_ctx.styleObj)
      }, [
        _withDirectives(_createElementVNode("img", {
          alt: "",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.jumpPage && _ctx.jumpPage(...args)))
        }, null, 512), [
          [_directive_lazy, _ctx.imgUrl]
        ])
      ], 4))
    : _createCommentVNode("", true)
}